<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <p class="modal-notice">적용할 비즈니스를 선택해주세요.</p>
            <div class="scroll-inner">
              <ul class="ticket-list pd0" v-if="!isEmpty(list)">
                <li
                  class="card ticket"
                  v-for="item in list"
                  @click="selectTicket = item.businessNo"
                  :class="item.businessNo === selectTicket ? 'on' : ''"
                >
                  <div class="title-wrap">
                    <h3 class="title">{{ item.name }}</h3>
                  </div>
                </li>
              </ul>
              <div class="empty-wrap" v-if="isEmpty(list)">
                <div class="empty">
                  <div>적용할 비즈니스가 없습니다.</div>
                </div>
              </div>
            </div>
          </div>
          <basic-button
            modal-btn
            left-text="닫기"
            @left-event="close"
            @right-event="done"
            right-text="선택"
            left-inner-class="medium border-gray"
            right-inner-class="primary medium"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import BasicButton from '@/components/common/layouts/BasicButton.vue';
import { computed, ref, toRefs } from 'vue';
import { isEmpty } from '@/common/utils/Util';
import store from '@/store';
import { showTextModal } from '@/common/utils/ModalState';

const props = defineProps(['data']);
const { list } = toRefs(props.data);
const { doneCallback } = props.data;
const emits = defineEmits(['close']);
const user = computed(() => store.getters['user/getUserData']);

const selectTicket = ref();

const done = () => {
  if (isEmpty(selectTicket.value)) {
    showTextModal('적용할 비즈니스를 선택해주세요.', '확인');
    return false;
  }
  if (doneCallback) doneCallback(list.value.find(business => business.businessNo === selectTicket.value));
  close();
};

const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
